import Buttons from '@klv/molecules/buttons';
import Icon from '@klv/atoms/icon';
import { generateClassName, getColorVariantFromBackground } from '@klv/shared/utils/functions';

import * as styles from './styles/testimonialsQuote.module.scss';

import type { ITestimonialsQuote } from './types';

const TestimonialQuote = ({
  attributionLine,
  backgroundColor,
  buttons,
  className,
  classNames,
  logo,
  quoteText,
  variant = 'solid_background',
  ...rest
}: ITestimonialsQuote) => {
  const colorVariant = variant === 'solid_background' ? getColorVariantFromBackground(backgroundColor) : 'light';

  const { textWrapper, quoteIcon } = classNames || {};

  return (
    <div
      className={generateClassName([
        'testimonialQuote',
        className,
        styles.testimonialQuote,
        styles[backgroundColor],
        variant === 'gradient_background' && styles.gradientBackground,
      ])}
      {...rest}
    >
      <div className={generateClassName(['grid', styles.grid])}>
        <div className={generateClassName([styles.textWrapper, textWrapper])}>
          {variant === 'solid_background' && (
            <Icon
              className={
                generateClassName([
                  styles.icon,
                  quoteIcon,
                ])}
                fillColor='currentColor'
                iconName='Quote'
                size={3.2}
              />
          )}
          <blockquote className={generateClassName([variant === 'solid_background' ? 'testimonialsQuote' : 'h2'])} dangerouslySetInnerHTML={{ __html: quoteText }} />
          {logo && (
            <img
              alt={logo.altText}
              className={styles.logo}
              height={logo.mediaDetails?.height}
              sizes='(max-width: 340px) 100vw, 300px'
              src={logo.sourceUrl}
              srcSet={logo.srcSet}
              width={logo.mediaDetails?.width}
            />
          )}
          <div className={generateClassName([styles.attributionName, 'tagline'])}>{attributionLine?.name}</div>
          <div className={generateClassName([styles.attributionTitle, 'tagline'])}>{attributionLine?.title}</div>
          {buttons?.length && (
            <Buttons
              buttonColor={colorVariant}
              buttons={buttons}
              className={styles.buttons}
              variants={['tertiary']}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TestimonialQuote;
